/**
 * The last page visited inside each campaign, per device, so reopening the
 * app or a campaign lands where the reader left rather than on the overview.
 * A convenience like `lastUsed.ts`: an unreadable or refused value falls back
 * to the caller's default.
 */

const keyFor = (campaignId: string): string => `socialsrc.lastPage.${campaignId}`;

export function readLastPage(campaignId: string): string | null {
  try {
    return localStorage.getItem(keyFor(campaignId));
  } catch {
    return null;
  }
}

export function writeLastPage(campaignId: string, href: string): void {
  try {
    localStorage.setItem(keyFor(campaignId), href);
  } catch {
    // Quota exceeded or storage disabled: the overview still opens.
  }
}

/** A campaign destination (`orgContext`'s `CampaignDestination`) that prefers
 *  the page last visited in that campaign over `fallback`. */
export function lastPageOr(fallback: (campaignId: string) => string) {
  return (campaignId: string): string => readLastPage(campaignId) ?? fallback(campaignId);
}
